import EtSlider from "@/ts/components/EtSlider";
import {initAllElementArtikel} from "@/ts/elements/artikel/element_artikel";
import {artikelDetailSeiteAlternatingBackground} from "@/ts/pages/artikel/detail";

interface AdditionalData {
    add: any[];
    click: any[];
    view: any[];
    wish: any[];
}

declare var additional_data: AdditionalData;

declare const dataLayer: any[];

export type WidgetParameters = {
    "type": string,
    "template": string,
    "limit": string,
    "products": string
    "container": HTMLElement
}

/**
 * Funktion kopiert aus dev/customer_vbs/custom/module/public/vbsr/vbsr.js:1825 peeriusShowWidgets() und angepasst
 *
 */
export function loadLuigisBoxRecommendations(WidgetParameters: WidgetParameters) {
    if (typeof(window.etData.shopId) !== "undefined") {
        const url = new URL('/json.php', window.location.origin);
        url.searchParams.set('service', 'getRecommendationMarkup');
        url.searchParams.set('pres', window.etData.presenceId.toString());
        url.searchParams.set('shop', window.etData.shopId.toString());
        url.searchParams.set('context_vw_type', window.etData.vwType);
        url.searchParams.set('context_vw_name', window.etData.vwName);
        url.searchParams.set('context_vw_id', window.etData.vwId.toString());
        url.searchParams.set('lang', window.etData.lang);
        url.searchParams.set('template', WidgetParameters.template);
        url.searchParams.set('type', WidgetParameters.type);
        url.searchParams.set('limit', WidgetParameters.limit);
        url.searchParams.set('products', WidgetParameters.products);
        url.searchParams.set('user_id', getLbUserId());

        fetch(url)
            .then(response => response.json())
            .then((data: any) => {
                if (data && data.success && "html" in data) {
                    const container = WidgetParameters.container;
                    container.innerHTML = data.html;
                    container.closest('.js_luigisbox_recommendations_container')?.classList.remove('d-none');
                    artikelDetailSeiteAlternatingBackground();

                    // take care of sliders and slider buttons
                    EtSlider.initAllSliders();
                    // regular click handlers
                    initAllElementArtikel();

                    if ("tracking" in data) {
                        let trackingData = JSON.parse(data.tracking);
                        if (typeof trackingData.add !== "undefined") {
                            additional_data.add = {...additional_data.add, ...trackingData.add};
                        }
                        if (typeof trackingData.view !== "undefined") {
                            additional_data.view = {...additional_data.view, ...trackingData.view};
                        }
                        if (typeof trackingData.wish !== "undefined") {
                            additional_data.wish = {...additional_data.wish, ...trackingData.wish};
                        }
                        if (typeof trackingData.item !== "undefined") {
                            dataLayer.push(trackingData.item);
                        }
                        if (typeof trackingData.click !== "undefined") {
                            additional_data.click = trackingData.click;
                            container.querySelectorAll('.element_artikel a').forEach((el) => {
                                const anchor = el as HTMLAnchorElement;
                                anchor.addEventListener('click', () => {
                                    const id = anchor.dataset.id;
                                    if (id && additional_data.click[id]) {
                                        dataLayer.push(additional_data.click[id]);
                                    }
                                });
                            });
                        }
                    }
                }
            }).catch(error => console.error('Error:', error));
    }
}

function getLbUserId(): string {
    let nameEQ = encodeURIComponent('_lb') + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return '';
}